import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/dpca/commonProblems',
    name: 'dpcaCommonProblems',
    component: () =>
      import(
        /* webpackChunkName: "dpcaCommonProblems" */ '@/views/dpca/help-center/IndexView.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    path: '/dpca/commonProblems/detail',
    name: 'dpcaCommonProblemsDetail',
    component: () =>
      import(
        /* webpackChunkName: "dpcaCommonProblemsDetail" */ '@/views/dpca/help-center/DetailView.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
     path: '/dpca/intelligent-unlocking',
    name: 'dpcaIntelligentUnlocking',
    component: () =>
      import(
        /* webpackChunkName: "dpcaIntelligentUnlocking" */ '@/views/dpca/SmartLockerManual.vue'
      ),
    meta: {
      cname: '智能解闭锁'
    }
  },
    {
     path: '/dpca/activity/2026618',
    name: 'dpcaActivity2026618',
    component: () =>
      import(
        /* webpackChunkName: "dpcaActivity2026618" */ '@/views/dpca/activities/IndexYearMiddle.vue'
      ),
    meta: {
      cname: '神龙 2026 618'
    }
  },
  {
    path: '/dpca/activity/20261111',
    name: 'dpcaActivity20261111',
    component: () =>
      import(
        /* webpackChunkName: "dpcaActivity20261111" */ '@/views/dpca/activities/IndexDouble11.vue'
      ),
    meta: {
      cname: '神龙 2026 双11'
    }
  }
];
export default routes;
